<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Verify Client</h2>
        </span>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <div class="m-3">
          <div class="row">
            <div class="col-3">
              <div class="gray-bg-rounded">
                <form [formGroup]="verifyClientForm">
                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="bc">BC</label>
                    <p-select
                      id="brandingConsultant"
                      [(ngModel)]="bcUserDefaultSelectionId"
                      formControlName="brandingConsultant"
                      [options]="bcList"
                      pInputText
                      optionValue="projectName"
                      placeholder="Select brandingConsultant">
                      <ng-template let-option #selectedItem>
                        {{ option.personnelNumber }} : {{ option.projectName }}
                      </ng-template>
                      <ng-template let-item #item>
                        {{ item.personnelNumber }} : {{ item.projectName }}
                      </ng-template>
                    </p-select>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="country">Country</label>
                    <p-select
                      pInputText
                      id="country"
                      formControlName="country"
                      [options]="countryRegionList"
                      optionValue="countryRegionD365"
                      optionLabel="countryRegionD365"
                      [showClear]="true"
                      [filter]="true"
                      placeholder="Select Cotunry">
                    </p-select>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="c_name"
                      >Client Name<span class="madatory-field">*</span></label
                    >
                    <input
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      id="c_name"
                      pInputText
                      name="c_name"
                      placeholder=""
                      formControlName="clientName"
                      [ngClass]="{ 'has-error': formErrors['clientName'] }"
                      (blur)="logValidationErrors()"
                      (focusout)="trimValue($event)"
                      (keydown.enter)="verifyClient($event)" />

                    <span class="error-msg" *ngIf="formErrors['clientName']">
                      {{ formErrors["clientName"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="c_Address"
                      >Client Street Address</label
                    >
                    <textarea
                      rows="5"
                      cols="30"
                      pInputText
                      jniAutoCompleteBlocker
                      id="c_Address"
                      name="c_Address"
                      placeholder=""
                      formControlName="streetAddress"
                      [ngClass]="{ 'has-error': formErrors['streetAddress'] }"
                      (blur)="logValidationErrors()"
                      (focusout)="trimValue($event)"
                      (keydown.enter)="verifyClient($event)"></textarea>

                    <span class="error-msg" *ngIf="formErrors['streetAddress']">
                      {{ formErrors["streetAddress"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="zip">Zip</label>
                    <input
                      jniAutoCompleteBlocker
                      type="text"
                      pInputText
                      class="form-control"
                      id="zip"
                      name="zip"
                      placeholder=""
                      formControlName="zip"
                      (focusout)="trimValue($event)"
                      (keydown.enter)="verifyClient($event)" />
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="url">URL</label>
                    <input
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      id="url"
                      pInputText
                      name="url"
                      placeholder=""
                      formControlName="companyUrl"
                      [ngClass]="{ 'has-error': formErrors['companyUrl'] }"
                      (blur)="logValidationErrors()"
                      (focusout)="trimValue($event)"
                      (keydown.enter)="verifyClient($event)" />

                    <span class="error-msg" *ngIf="formErrors['companyUrl']">
                      {{ formErrors["companyUrl"] }}
                    </span>
                  </div>

                  <div class="form-group has-float-label mb-2">
                    <label class="form-label" for="duns">DUNS#</label>
                    <input
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      pInputText
                      id="duns"
                      name="duns"
                      placeholder=""
                      formControlName="dUNS"
                      [ngClass]="{ 'has-error': formErrors['dUNS'] }"
                      (blur)="logValidationErrors()"
                      (focusout)="trimValue($event)"
                      (keydown.enter)="verifyClient($event)" />

                    <span class="error-msg" *ngIf="formErrors['dUNS']">
                      {{ formErrors["dUNS"] }}
                    </span>
                  </div>

                  <div class="d-flex mb-2">
                    <p-button
                      label="Verify"
                      type="button"
                      (click)="onClientVerify()"
                      (keydown.enter)="onClientVerify()" />

                    <!-- <button
                      type="button"
                      (click)="onClientVerify()"
                      (keydown.enter)="onClientVerify()"
                      class="btn btn-primary">
                      Verify
                    </button> -->
                  </div>
                </form>
              </div>
            </div>

            <div class="vendors-info col-9">
              <div class="gray-bg-rounded">
                <p-table
                  #dt
                  stripedRows
                  [rowHover]="true"
                  [showCurrentPageReport]="true"
                  [scrollable]="true"
                  [size]="'small'"
                  [resizableColumns]="true"
                  [rows]="10"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [paginator]="true"
                  [value]="verifyClientList"
                  styleClass="p-datatable-customers verify-client-listing table-listing"
                  [rowHover]="true"
                  selectionMode="multiple"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  [filterDelay]="0">
                  <ng-template pTemplate="header">
                    <tr class="table-head">
                      <th>&nbsp;</th>
                      <th
                        pSortableColumn="clientName"
                        [ngClass]="{
                          trimmedby50char: descriptionCharacterCond,
                        }">
                        Client Name
                        <p-sortIcon field="createdDate"></p-sortIcon>
                      </th>
                      <th class="address">Address</th>
                      <th>BC</th>
                      <th>Protection</th>
                      <th class="date">Last Order Date</th>
                      <th class="date">Last Invoiced</th>
                      <th>Cust#</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>
                        <div class="d-flex">
                          <input
                            jniAutoCompleteBlocker
                            pInputText
                            type="text"
                            name="clientName"
                            id="clientName"
                            style="max-width: 200px"
                            (input)="
                              dt.filter(
                                $any($event.target).value,
                                'clientName',
                                'contains'
                              )
                            "
                            placeholder=""
                            class="p-column-filter p-inputtext p-component" />
                        </div>
                      </th>
                      <th>
                        <div class="d-flex">
                          <input
                            jniAutoCompleteBlocker
                            pInputText
                            type="text"
                            name="clientPrimaryAddress"
                            id="clientPrimaryAddress"
                            style="max-width: 200px"
                            (input)="
                              dt.filter(
                                $any($event.target).value,
                                'clientPrimaryAddress',
                                'contains'
                              )
                            "
                            placeholder=""
                            class="p-column-filter p-inputtext p-component" />
                        </div>
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-verifyClientList
                    let-rowIndex="rowIndex">
                    <tr
                      class="p-selectable-row"
                      [pSelectableRow]="verifyClientList"
                      [pSelectableRowIndex]="rowIndex">
                      <td>
                        <!-- <i class="icon icon-Email me-2"></i>
                      <i
                        *ngIf="verifyClientList.protectionNumber === 0"
                        class="icon icon-acquire-client me-2"
                      ></i> -->
                      </td>
                      <td
                        [ngClass]="{
                          'trimmeddescription trimmedby50char':
                            descriptionCharacterCond,
                        }">
                        {{
                          descriptionCharacterCount(verifyClientList.clientName)
                        }}
                        {{ verifyClientList.clientName }}
                      </td>
                      <td class="address">
                        {{ verifyClientList.clientPrimaryAddress }}
                      </td>
                      <td>{{ verifyClientList.brandingconsultant }}</td>
                      <td>
                        <span class="pt-value">{{
                          verifyClientList.protectionNumber
                        }}</span>
                        <i
                          *ngIf="verifyClientList.protectionNumber !== 0"
                          class="icon icon-Protection-days ms-1"></i>
                        <i
                          *ngIf="verifyClientList.protectionNumber === 0"
                          class="icon danger icon-Protection-days ms-1"></i>
                      </td>

                      <td class="date">
                        <span
                          *ngIf="
                            verifyClientList.lastOrderDate | hidedynamicsdate
                          ">
                          {{
                            verifyClientList.lastOrderDate | date: "MM-dd-yyyy"
                          }}
                        </span>
                      </td>
                      <td class="date">
                        <span
                          *ngIf="
                            verifyClientList.lastInvoiceDate | hidedynamicsdate
                          ">
                          {{
                            verifyClientList.lastInvoiceDate
                              | date: "MM-dd-yyyy"
                          }}
                        </span>
                      </td>
                      <td>{{ verifyClientList.customerAccount }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="20">No clients found.</td>
                    </tr>
                  </ng-template>
                </p-table>

                <div class="clients-note text-center pt-4">
                  <h2>
                    I have reviewed the clients above per the Statement of
                    Policy and would like to :

                    <p-button
                      [disabled]="!verifyClientForm.valid"
                      [ngClass]="
                        showCreateClientBtn ? 'primary' : 'link-disable'
                      "
                      (click)="redirectToCreateClient()"
                      (keydown.enter)="onClientVerify()"
                      label="Create Client" />

                    <!-- <button
                      [disabled]="!verifyClientForm.valid"
                      [ngClass]="
                        showCreateClientBtn ? 'btn btn-primary' : 'link-disable'
                      "
                      (click)="redirectToCreateClient()"
                      style="font-size: 18px">
                      Create Client
                    </button> -->
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
